import { ModelFactory } from '../../definitions/models';
import { ConversationThreadAttachmentSchema } from '../../definitions/schemas';
import { ListEntry } from '../../lib/Lists';

type AttachmentType = Required<
  Pick<
    ConversationThreadAttachmentSchema,
    'filename' | 'filesize' | 'mime' | 'uri'
  >
>;

export const AttachmentModel = ModelFactory<AttachmentType>({
  filename: '',
  filesize: 0,
  mime: '',
  uri: '',
});

class AttachmentEntry extends ListEntry<AttachmentType> {
  completed = false;

  error: string | null = null;

  file: File;

  uploading = false;

  constructor(model: AttachmentType, file: File) {
    super(model);
    this.file = file;
  }
}

export default AttachmentEntry;
